// frontend/src/api/questionnaires.js
import client from './client';

const COACH = '/coach-hub/questionnaires';

export const questionnairesApi = {
  // --- Coach: templates ---
  listTemplates: (includeArchived = false) =>
    client.get(`${COACH}/templates`, { params: { include_archived: includeArchived } }),
  getTemplate: (id) => client.get(`${COACH}/templates/${id}`),
  createTemplate: (body) => client.post(`${COACH}/templates`, body),
  updateTemplate: (id, body) => client.patch(`${COACH}/templates/${id}`, body),
  archiveTemplate: (id) => client.delete(`${COACH}/templates/${id}`),
  duplicateTemplate: (id) => client.post(`${COACH}/templates/${id}/duplicate`),

  // --- Coach: assignments ---
  listAssignments: (params = {}) => client.get(`${COACH}/assignments`, { params }),
  getAssignment: (id) => client.get(`${COACH}/assignments/${id}`),
  sendAssignment: (body) => client.post(`${COACH}/assignments`, body),
  reviewAssignment: (id, body) => client.post(`${COACH}/assignments/${id}/review`, body),
  cancelRecurrence: (id) => client.post(`${COACH}/assignments/${id}/cancel-recurrence`),
  deleteAssignment: (id) => client.delete(`${COACH}/assignments/${id}`),

  // --- Client ---
  myList: (status) => client.get('/questionnaires', { params: status ? { status } : {} }),
  my: (id) => client.get(`/questionnaires/${id}`),
  saveDraft: (id, responses) => client.patch(`/questionnaires/${id}/draft`, { responses }),
  submit: (id) => client.post(`/questionnaires/${id}/submit`),
  uploadPhoto: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post(`/questionnaires/${id}/photo`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
